const invalid = (reason) => Object.assign(new Error(`Invalid shading calculation: ${reason}; missing or invalid roof samples`), { code: 'INVALID_SHADING_SAMPLES' });

export const captureShadingMasks = ({ roofPixels, segmentPixels, width, height, ranges, segmentCount }) => {
  if (!Number.isInteger(width) || !Number.isInteger(height) || width <= 0 || height <= 0 ||
    !Number.isInteger(segmentCount) || segmentCount <= 0 ||
    roofPixels?.length !== width * height * 4 || segmentPixels?.length !== width * height * 4 ||
    !Array.isArray(ranges) || ranges.length < 4 || !ranges.slice(0, 4).every(Number.isFinite)) {
    throw invalid('missing roof mask');
  }
  if (ranges[0] > ranges[2] || ranges[1] > ranges[3] || !ranges.slice(0, 4).every(Number.isInteger)) throw invalid('mask bounds');
  const bounds = [Math.max(0, ranges[0]), Math.max(0, ranges[1]), Math.min(width - 1, ranges[2]), Math.min(height - 1, ranges[3])];
  const [minx, miny, maxx, maxy] = bounds;
  const roof = new Uint8ClampedArray(roofPixels);
  const segments = new Uint8ClampedArray(segmentPixels);
  const counts = new Array(segmentCount).fill(0);
  const pixels = [];
  for (let y = miny; y <= maxy; y += 1) {
    for (let x = minx; x <= maxx; x += 1) {
      const pixel = y * width + x;
      if (roof[pixel * 4] === 0) continue;
      const segment = segments[pixel * 4] - 1;
      // Anti-aliased polygon borders can round their low-valued segment label to zero.
      if (segment < 0 || segment >= segmentCount) continue;
      counts[segment] += 1;
      pixels.push(pixel);
    }
  }
  if (counts.some((count) => count === 0)) throw invalid('roof has no shading samples');
  return { roof, segments, pixels, counts, width, height, ranges: bounds, renderRanges: ranges.slice(), segmentCount };
};

export const finiteShadingRatio = (sum, count) => {
  if (!Number.isFinite(sum) || !Number.isFinite(count) || count <= 0) throw invalid('non-finite roof factors');
  const value = sum / count;
  if (!Number.isFinite(value)) throw invalid('non-finite roof factors');
  return value;
};

export const validateShadingSamples = (periods, masks, channels = 1) => {
  periods.forEach((period) => {
    if (!Array.isArray(period) || period.length !== 3) throw invalid('missing shading period');
    period.forEach((values) => {
      if (!values || values.length !== masks.width * masks.height * channels) throw invalid('texture dimensions');
      masks.pixels.forEach((pixel) => {
        const value = values[pixel * channels];
        if (!Number.isFinite(value) || value < 0 || value > 1) throw invalid('non-finite shading samples');
      });
    });
  });
};

export const validateAnnualShading = (monthly, annual, masks, channels = 1) => {
  validateShadingSamples([...monthly, annual], masks, channels);
  for (let field = 0; field < 3; field += 1) {
    const annualHasValue = masks.pixels.some((pixel) => annual[field][pixel * channels] > 0);
    const monthlyHasValue = monthly.some((period) => masks.pixels.some((pixel) => period[field][pixel * channels] > 0));
    if (!annualHasValue && monthlyHasValue) throw invalid('annual shading is inconsistent with monthly results');
  }
};
